export default "__VITE_ASSET__DHVZhfAE__"